import config from 'config';
import React from 'react';

const Footer = (props) => (
  <footer style={props.style}>
    <section className="wrapper">
      <section className="main">
        
        <div className="stores-wrapper">
          <p>Você pode levar toda essa informação no seu bolso, e não precisa parar por aqui.</p>

          <a href={config.appStore} title="Baixar na App Store" target="_blank">
            <img alt="" src={require("../img/icon-btn-download-app-store.png")} />
          </a>

          <a href={config.playStore} title="Disponível no Google Play" target="_blank">
            <img alt="" src={require("../img/icon-btn-download-google-play.png")} />
          </a>
        </div>

        <img src={require('../img/footer-app-screen.png')} alt="" className="screen" />
      </section>
    </section>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js